import { useMemo, useState } from "react";
import { freshList, type FreshCategory } from "@/mocks/gossip";

const cats: FreshCategory[] = [
  "全部",
  "课堂",
  "宿舍",
  "恋爱",
  "社团",
  "食堂",
  "校园",
];

const tone: Record<string, string> = {
  课堂: "bg-secondary-100 text-secondary-900",
  宿舍: "bg-accent-100 text-accent-800",
  恋爱: "bg-primary-100 text-primary-700",
  社团: "bg-accent-100 text-accent-800",
  食堂: "bg-secondary-100 text-secondary-900",
  校园: "bg-background-300 text-foreground-800",
};

export default function FreshFeed() {
  const [active, setActive] = useState<FreshCategory>("全部");

  const list = useMemo(
    () =>
      active === "全部"
        ? freshList
        : freshList.filter((f) => f.category === active),
    [active]
  );

  return (
    <section id="fresh" className="bg-background-50 py-14 md:py-20">
      <div className="mx-auto max-w-6xl px-4 md:px-6">
        <div className="flex flex-col gap-5 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 rounded-full bg-accent-500 px-3 py-1 text-[11px] font-medium text-background-50">
              <i className="ri-flashlight-fill"></i> 实时速递
            </span>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
              校园八卦新鲜事
            </h2>
            <p className="mt-2 text-sm text-foreground-500">
              课堂、宿舍、恋爱、社团……今天校园里正在发生的那些事儿。
            </p>
          </div>

          {/* 分类切换 */}
          <div className="nice-scroll flex flex-wrap items-center gap-2 overflow-x-auto">
            {cats.map((c) => (
              <button
                key={c}
                type="button"
                onClick={() => setActive(c)}
                className={`whitespace-nowrap rounded-full px-1 py-1 text-sm transition ${
                  active === c
                    ? "bg-primary-500 text-background-50"
                    : "bg-transparent text-foreground-600 hover:bg-background-100"
                }`}
              >
                <span className="px-3 py-1.5">{c}</span>
              </button>
            ))}
          </div>
        </div>

        <div className="mt-8 grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
          {list.map((item) => (
            <article
              key={item.id}
              className="group flex flex-col rounded-2xl border border-background-200 bg-background-100/60 p-5 transition hover:-translate-y-1 hover:border-primary-200 hover:bg-background-50 hover:shadow-lift"
            >
              <div className="flex items-center justify-between gap-2">
                <span
                  className={`inline-flex items-center gap-1 whitespace-nowrap rounded-md px-2 py-1 text-[11px] font-medium ${tone[item.category]}`}
                >
                  {item.category}
                </span>
                {item.isNew && (
                  <span className="flex items-center gap-1 whitespace-nowrap text-[11px] font-medium text-primary-600">
                    <span className="h-1.5 w-1.5 rounded-full bg-primary-500"></span>
                    刚刚
                  </span>
                )}
              </div>

              <h3 className="mt-3 text-[15px] font-semibold leading-relaxed text-foreground-950 transition group-hover:text-primary-700">
                {item.title}
              </h3>
              <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">
                {item.summary}
              </p>

              <footer className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                <time>{item.time}</time>
                <div className="flex items-center gap-3">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {item.views}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-chat-3-line"></i>
                    {item.comments}
                  </span>
                </div>
              </footer>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}